{
  "en": {
    "translation": {
      "widgetParametersTitle": "Look & feel",
      "widgetParametersHelp": "Click on a swatch to change a color variable's value across the theme",
      "mainViewerTitle": "Main view",
      "widgetBackground": "Gallery background",
      "cloudinaryRights": "2020 Cloudinary. All rights reserved",
      "signUp": "Sign up for free",
      "signUpMobile": "Sign up",
      "easyToCustomize": "Easy to Customize",
      "tryIt": "Try it",
      "editThisExample": "Edit this example",
      "termsOfUse": "Terms of use",
      "privacyPolicy": "Privacy Policy",
      "contactUs": "Contact Us",
      "documentation": "Documentation",
      "overview": "Overview",
      "productGallery": "Product Gallery",
      "uploadWidgetDemo": "Product Gallery demo",
      "easyCustomization": "Easy customization",
      "urlTransformation": "Transformations",
      "imageTransformation": "Image transformation",
      "replaceShirtColor": "Replace shirt color",
      "layoutMobileText": "Only the \"Classic\" mode is supported for mobile devices.",
      "embedText": "Overlay text",
      "embedTextSuffix": "% sale",
      "remove": "Remove",
      "watermark": "Watermark",
      "buttonCustomization": "Button customization",
      "uploadWatermark": "Upload watermark",
      "eventsAndAnalytics": "Events & Analytics",
      "events": "Events",
      "shape": "Button shape",
      "color": "Button colors",
      "customize": "Customize",
      "preview": "Preview",
      "code": "Code",
      "copyToClipBoard": "Copy to clipboard",
      "bgColorLabel": "Background color",
      "placeHolderEffectLabel": "Placeholder effect",
      "customTransformation": "Custom transformation",
      "resetDemo": "Reset",
      "clearAll": "Clear all changes and reset to default",
      "transformationLabel": "Custom transformation",
      "layoutLabel": "Layout",
      "classic": "Classic",
      "oneColumn": "Expanded - 1 column",
      "twoColumn": "Expanded - 2 columns",
      "threeColumn": "Expanded - 3 columns",
      "aspectRatioLabel": "Aspect ratio",
      "zoomLabel": "Show zoom",
      "zoomLevelLabel": "Zoom level",
      "paletteLabel": "Theme colors",
      "primaryLabel": "Media background",
      "onPrimaryLabel": "Media icon",
      "activeLabel": "Selected",
      "transitionLabel": "Transition",
      "aspectRatioMoreLabel": "More ratios",
      "carouselLocationLabel": "Carousel location",
      "carouselOffsetLabel": "Carousel offset",
      "carouselButtonShape": "Carousel button shape",
      "carouselButtonColor": "Carousel button colors",
      "zoomTitle": "Zoom",
      "viewerPositionLabel": "Zoom viewer position",
      "zoomTypeLabel": "Zoom Type",
      "zoomStepsLabel": "Zoom steps",
      "zoomTriggerLabel": "Zoom trigger",
      "borderWidthLabel": "Border width",
      "BorderColorLabel": "Border color",
      "borderRadiusLabel": "Border radius",
      "showLensLabel": "Show lens",
      "lensOpacityLabel": "Opacity",
      "lensBorderWidthLabel": "Lens border width",
      "lensShadowLabel": "Lens shadow",
      "changeOnHoverLabel": "changeOnHover",
      "mediaSymbolShadowLabel": "Icon shadow",
      "carouselStyleLabel": "Carousel style",
      "widthLabel": "Width",
      "heightLabel": "Height",
      "spacingLabel": "Spacing",
      "gutterLabel": "Gutter",
      "radiusLabel": "Radius",
      "selectedStyleLabel": "Selected style",
      "selectedGradientStartLabel": "Gradient start",
      "selectedGradientEndLabel": "Gradient end",
      "selectedGradientDirectionLabel": "Gradient direction",
      "selectedBorderColorLabel": "Selected border color",
      "selectedBorderPositionLabel": "Selected border position",
      "selectedGradientOpacityLabel": "Gradient opacity",
      "selectedBorderWidthLabel": "Selected border width",
      "selectedBorderOpacityLabel": "Border opacity",
      "navigationStyleLabel": "Navigation style",
      "thumbnailNavigationLabel": "Navigation button shape",
      "sizeLabel": "Size",
      "colorLabel": "Color",
      "iconColorLabel": "Icon color",
      "iconBackgroundLabel": "Background color",
      "background": "Background",
      "buttonShapeLabel": "Button shape",
      "navigationLabel": "Navigation visibilty",
      "navigationBorderColorLabel": "Border color",
      "navigationColorLabel": "Navigation button colors",
      "navigationIconColorLabel": "Icon color",
      "navigationBorderWidthLabel": "Border width",
      "navigationSizeLabel": "Size",
      "navigationPositionLabel": "Position",
      "mediaSymbolBgShapeLabel": "Media button shape",
      "navigationFloatLabel": "Float",
      "navigateOnHoverLabel": "Navigate on mouseover",
      "carouselTitle": "Carousel",
      "currentlySelectedTitle": "Selected thumbnail",
      "thumbnailsTitle": "Thumbnails",
      "indicatorShapeLabel": "Indicators shape",
      "learnMore": "Learn more",
      "expandSection" : "Expand Section",
      "collapseSection" : "Collapse Section",
      "codeTabTooltip" : "View the generated code according to your customized parameters.",

      "pageIntroText": {
        "product": "Integrate a modern, responsive, flexible product gallery into your product details page with just a few lines of JavaScript. Cloudinary's <a href=\"https://cloudinary.com/documentation/product_gallery\" target=\"_blank\">Product Gallery</a> has saved hundreds of hours of development time for iconic e-Commerce brands.",
        "events": "Track how customers use the product gallery by capturing <a href=\"https://cloudinary.com/documentation/product_gallery#gallery_events\" target=\"_blank\">relevant events</a>. This information can be passed to analytics engines like Google Analytics or used to trigger custom behavior.",
        "transformation": "You can easily access Cloudinary's powerful and extensive library of <a href=\"https://cloudinary.com/documentation/image_transformation_reference\" target=\"_blank\">image</a> and <a href=\"https://cloudinary.com/documentation/video_transformation_reference\" target=\"_blank\">video</a> transformations to apply effects, face detection, watermarks or any of a multitude of other options. This example integrates the <a href=\"https://cloudinary.com/documentation/image_transformation_reference#effect_parameter\" target=\"_blank\">replace_color</a> effect to dynamically create product images in a variety of colors - from a single uploaded image."
      }
    }
  }
}
